<template>
    <div class="containerNcm">   
        <div class="painel2">
        <img src="/arqlef/arqlef2.svg" alt="" />
        </div>
        <b-modal id="modalEm"  ref="modalEm" title="BootstrapVue">
          <p style="color:#707070;font-weight:bold;font-size:22px;margin-top:40px;">Deseja mesmo excluir a empresa?</p><br>
          <div>            
            <button style="background: #AD3F3F;margin-right:10px;" @click="naoEmpresa()">Não</button>
            <button style="background: #009188;margin-left:10p;x" @click="simEmpresa()" :disabled="disabledCer">Sim</button>
          </div>
        </b-modal>
        <b-modal id="modalCertificado"  ref="modalCertificado" title="BootstrapVue">
          <p style="color:#707070;font-weight:bold;font-size:22px;margin-top:40px;">Deseja mesmo excluir o certificado?</p><br>
          <div>            
            <button style="background: #AD3F3F;margin-right:10px;" @click="naoCertificado()">Não</button>
            <button style="background: #009188;margin-left:10p;x" @click="simCertificado()" :disabled="disabledCer">Sim</button>
          </div>
        </b-modal>
        <div class="empresas">
           <div>
                <p class="txtEmpresa">Empresas cadastradas</p> 
                <p style="font-style:italic; font-size:18px;color:#000;">{{qntEmpresa}} empresa<span v-if="qntEmpresa != 1">s</span> registradas</p>
            </div>
        </div>
        <div id="tableDiv">
            <div v-if="spiner">
          <div v-if="!msgErroBusca">
            <table class="width: 100%; max-width: 100%;">
              <thead>
                <tr>
                    <td></td>
                  <td></td>
                  <td>
                    Empresa (Razão Social)
                  </td>
                  <td>
                    CNPJ
                  </td>
                  <td>
                    UF
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(e, i) in empresas" :key="i">
                  <td>
                       <img src="https://www.lefisc.com.br/arqlef/excluir.svg" alt="" width="20px" style="cursor:pointer;" @click="excluirEmpresa(e.idEmpresa)">
                  </td>
                  <td>
                    <div
                      v-if="!e.possuiCertificado"
                      class="cadastrarE"
                      @click="cadastrarCertificado(e.razaoSocial,e.idEmpresa)"
                    >
                      Cadastrar Certificado
                    </div>
                    <div
                      v-else
                      class="cadastrarE"
                      style="background:red;"
                      @click="excluirCertificado(e.idEmpresa)"
                    >
                      Excluir Certificado
                    </div>
                  </td>
                  <td>
                    {{ e.razaoSocial }}
                  </td>
                  <td>
                    {{ e.cnpj }}
                  </td>
                  <td>
                    {{ e._uf }}
                  </td>
                  <td>
                    <div class="btnajuste">
                      <button @click="continuar(e.razaoSocial,e.idEmpresa)">
                        Visualizar Notas
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>           
          </div>
          <div v-else>
            <p
              style="text-align:center;margin-top: 80px; color: #707070;font-weight: 600;"
            >
              {{ msgErroBusca }}
            </p>
          </div>
           <div>
              <button class="btnLC" @click="IrParaPage()">+ Adicionar nova empresa</button>
            </div>
        </div>
        <div style="padding-top:40px;" v-else>
          <div class="d-flex justify-content-center mb-3">
             <div class="spinerMedio">
            
          </div>
          </div>
        </div>
        <vue-topprogress ref="topProgress"></vue-topprogress>
        <CadCertificado> </CadCertificado>
        </div>
    </div>
</template>

<script>
import config from '../services/config.js'
import CadCertificado from '../shared/CadCertificado.vue'
import { vueTopprogress } from "vue-top-progress";
import barramento from '@/services/barramento'
export default {
  components: { CadCertificado,vueTopprogress },
    data(){ 
        return{
            qntEmpresa:0,
            msgLista:"",
            spiner:false,
            msgErroBusca:"",
            empresas:[],
            disabledCer:false
        }
    },
    methods:{
      IrParaPage(){
        this.$router.push({
        name: "cadastrarempresa",
      });
      },
       async simEmpresa(){
        this.disabledCer = true
        this.$refs.topProgress.start();
        await config.excluirEmpresa(this.$store.state.idEmpresa,this.$store.state.idCliente)
         this.$refs['modalEm'].hide()
        this.$refs.topProgress.done();
        this.disabledCer = false
        this.buscarEmpresa()
      },
      async simCertificado(){
        this.disabledCer = true
        this.$refs.topProgress.start();
        await config.deletarCertificado(this.$store.state.idEmpresa)
        this.$refs['modalCertificado'].hide()
        this.$refs.topProgress.done();
        this.disabledCer = false
        this.buscarEmpresa()
      },
      naoEmpresa(){
        this.$refs['modalEm'].hide()
      },
      naoCertificado(){
        this.$refs['modalCertificado'].hide()
      },
        excluirEmpresa(id){
          this.$store.state.idEmpresa = id
          this.$refs['modalEm'].show()
        },
        cadastrarCertificado(r,id){             
          this.$store.state.razaoSocial =r
          this.$store.state.idEmpresa = id                 
          barramento.$emit('acionarModalDeListaEmpresa')
        },
        continuar(r,id){
          this.$store.state.razaoSocial =r
          this.$store.state.idEmpresa = id 
          let jsonAux = JSON.stringify({"razaoSocial":r,"idEmpresa":id,"chave":""});
          sessionStorage.setItem('objCli',jsonAux);
          this.$router.push({
                name:'notas'
                })
        },
        excluirCertificado(id){
          this.$store.state.idEmpresa = id
          this.$refs['modalCertificado'].show()
        },
        verificarStatus(status,nome){
            if(status.status >=400){
                this[nome] = status.data.message
            }else{
                this.empresas = status.data
                this.qntEmpresa = this.empresas.length
            }
            this.spiner = true
        },
        async buscarEmpresa(){
            this.spiner = false
            let status = await config.empresasCliente(this.$store.state.idCliente);
            this.verificarStatus(status, "msgErroBusca");   
        },
    },  
    mounted(){
        document.documentElement.scrollTop = 0;
        this.buscarEmpresa();
        
        
    }
}
</script>

<style>
.btnLC{
    width: 240px;
    height: 40px;
    border-radius: 10px;
    color: #fff;
    background: #009188;
    border: none;
    font-size: 15px;
    margin-top:80px;
}
.btnLC:focus{
  outline: none;
}
 #tableDiv table {
  width: 100%;
}
#tableDiv tbody tr:nth-child(odd) {
  background: #0091881A;
}
 #tableDiv table tr,
 #tableDiv td {
  white-space: nowrap;
}
 #tableDiv table thead td {
  color: #707070;
  font-size: 15px;
}
#tableDiv table td {
  padding: 8px;
  padding-top: 7px;
  font-size: 15px;
  color:#000;
  font-weight: 600;
}
.txtEmpresa{
    color: #000;
    font-size: 1.8em;
    font-weight: bold;
    margin-top: 40px;
    text-align: center;
    border-bottom: 1px solid #707070;
    padding-bottom: 5px;
    width: 350px;
    margin-bottom: 5px;
}
.empresas{
    display: flex;
    justify-content: center;
    align-content: center;
   width: 100%;
}
#tableDiv{
    width: 100%;
    padding:40px 30px;
}
#tableDiv .btnajuste button {
    width: 190px;
    height: 35px;
    border-radius: 10px;
    color: #fff;
    background: #009188;
    border: none;
    font-weight: 600;
    font-size: 14px;
}
#tableDiv .btnajuste button:focus {
    outline: none;
}
.cadastrarE {
    background: #009188 0 0 no-repeat padding-box;
    border-radius: 5px;
    width: 150px;
    height: 34px;
    font-weight: 600;
    color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 13px;
    cursor: pointer;
}
#modalCertificado{
  text-align: center;
}
header#modalCertificado___BV_modal_header_ {
    display: none;
}
footer#modalCertificado___BV_modal_footer_{
    display: none;
}
#modalCertificado button{
    text-align: center;
    outline: none;
    width: 75px;
    height: 35px;
    border:none;
    font-size: 14px;
    color:#fff;    
    border-radius: 5px;
    margin-top:20px;
    margin-bottom: 20px;
}
#modalEm button:focus{
    outline: none;
}
#modalEm{
  text-align: center;
}
header#modalEm___BV_modal_header_ {
    display: none;
}
footer#modalEm___BV_modal_footer_{
    display: none;
}
#modalEm button{
    text-align: center;
    outline: none;
    width: 75px;
    height: 35px;
    border:none;
    font-size: 14px;
    color:#fff;    
    border-radius: 5px;
    margin-top:20px;
    margin-bottom: 20px;
}
#modalEm button:focus{
    outline: none;
}
</style>